import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4e0fa370")

_pushScopeId("data-v-4e0fa370")
const _hoisted_1 = { class: "basic-data-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      border: "",
      "show-header": false,
      style: {"width":"721px"}
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          width: "180",
          className: "col"
        }),
        _createVNode(_component_el_table_column, {
          prop: "value",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name2",
          width: "180",
          className: "col"
        }),
        _createVNode(_component_el_table_column, {
          prop: "value2",
          width: "180"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_table, {
      data: _ctx.violationData,
      border: "",
      "show-header": false,
      style: {"width":"300px"}
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          width: "150",
          className: "col"
        }),
        _createVNode(_component_el_table_column, { prop: "value" })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
})